import useAppStore from "@/context/store";
import useRequest from "@/utils/useReq";
import { useState } from "react";
import { getBoardInfo, getCollections } from "../../services";
import HBModel from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import SwitchModalWrap from "../HBModal/SwitchModalWrap";
import HBConfirm from "../HBModal/confirm";
import Creator from "./creator";
import Editor from "./editor";
import styles from "./index.module.less";

/**
 *
 * @param {Object} props
 * @param {Object?} props.defaultData 默认表单数据 仅在创建时使用
 * @returns
 */
function RawBoardModel(props) {
  const [width, setWidth] = useState(480);
  const [title, setTitle] = useState(props.boardId ? "修改画板" : "创建画板");
  const [bodyStyle, setBodyStyle] = useState({
    padding: "12px 24px 24px 24px",
  });

  const collectionId = props.collectionId;
  const categories = useAppStore((store) => store.categories);
  const user = useAppStore((s) => s.user);
  const extra = user?.extra;
  const userId = user?.user_id;
  const isPro = extra?.pro;
  const isDesigner = extra?.is_museuser;

  const board = useRequest(getBoard);

  async function getBoard() {
    if (!props.boardId) return {};

    return getBoardInfo(props.boardId, { cover: true, pins: 4 }).then(
      (data) => {
        if (data.err) {
          props.onCancel && props.onCancel();
          return null;
        }
        return {
          ...data.board,
          category: data.board.category_id || undefined,
          collection_id: data.board.extra?.collection_id || undefined,
        };
      }
    );
  }

  const { data: collections = [] } = useRequest(
    async () => {
      const result = await getCollections(userId);
      return result?.collections || [];
    },
    {
      refreshDeps: [userId],
    }
  );

  // 无数据
  if (!board.data) {
    return null;
  }

  return (
    <HBModel
      key={props.boardId}
      {...props}
      title={title}
      footer={null}
      width={width}
      bodyStyle={bodyStyle}
      className={styles.modal}
      destroyOnClose
      centered
    >
      {props.boardId ? (
        <Editor
          {...props}
          key={props.boardId}
          board={board.data}
          categories={categories}
          isPro={isPro}
          isDesigner={isDesigner}
          refresh={board.refreshAsync}
          onPageChange={(mod) => {
            if (mod === 1) {
              setWidth(720);
              setTitle("设置封面");
              setBodyStyle({
                padding: "24px 0",
              });
            } else {
              setWidth(480);
              setTitle("修改画板");
              setBodyStyle({
                padding: "12px 24px 24px 24px",
              });
            }
          }}
        />
      ) : (
        <Creator
          {...props}
          isPro={isPro}
          isDesigner={isDesigner}
          categories={categories}
          defaultData={props.defaultData}
          collectionId={collectionId}
          collections={collections}
        />
      )}
    </HBModel>
  );
}

const BoardModal = SwitchModalWrap([ModalWrap(RawBoardModel), HBConfirm]);

export default BoardModal;
